import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import HomeIcon from '@material-ui/icons/Home';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

import { AiOutlineHome } from 'react-icons/ai';
import { ImUsers } from 'react-icons/im';
import { SiAzureartifacts } from 'react-icons/si';
import AttachFileIcon from '@material-ui/icons/AttachFile';

const MenuNavegacaoItem = [
    {
        icone : <HomeIcon></HomeIcon>,
        titulo : 'Inicio',
        link : ''
    },
    {
        icone : <PeopleAltIcon></PeopleAltIcon>,
        titulo : 'Usuarios',
        link : 'usuarios'
    },
    {
        icone : <AttachFileIcon></AttachFileIcon>,
        titulo : 'Produtos',
        link : 'produtos'
    },
    
    {
        icone : <SiAzureartifacts></SiAzureartifacts>,
        titulo : 'Fornecedores',
        link : 'fornecedores'
    },
]

export default MenuNavegacaoItem